export default "__VITE_ASSET__7266c065__"